package com.bikompanion.domain

/**
 * The id a bike's votes are filed under, which is not always the id its network is published as.
 *
 * A [BikeKey] means "bike 1234 in *this* numbering scheme", and a scheme belongs to an operator's
 * fleet rather than to however a data source chose to slice it. CityBikes slices AMBici into
 * seventeen municipal networks over one fleet with one set of bike numbers, so filing votes under
 * the published ids would scatter one bike's history across up to seventeen keys — a rider who
 * rated a bike in Badalona would find nothing when they checked the same bike in Cornellà.
 *
 * [AmbiciNetworkId] is the id the operator's own GBFS feed uses, so collapsing to it also keeps
 * votes cast under either data source in the same place.
 *
 * Matched on the name as well as the id because the two sources disagree on the id: a station
 * always knows the id it came from, while the name only arrives once the networks list has loaded.
 */
fun ratingScopeIdOf(network: BikeNetwork): String =
    when {
        network.id.isAmbici() || network.name.isAmbici() -> AmbiciNetworkId
        else -> network.id
    }

private fun String.isAmbici() = contains(AmbiciNetworkId, ignoreCase = true)
